import React from 'react';
import axios from "axios";
import Navbar from "../components/Navbar";
import VideoList from "../components/VideoList";
import { utilLoopHelper } from "../utils";
import Footer from "../components/Footer";
import { pageFilter, getArtistCookie, hasAnoAccess, gotoJoinPage } from "../data/page_data";
import Loading from "../components/loading";
import CssLoader from '../components/CssLoader';
import { parse } from 'query-string';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { FacebookShareButton, TwitterShareButton } from 'react-share';
import { Button } from 'reactstrap';
import {navigate} from '@reach/router';
import * as ReactGA from "react-ga";
import FloatingButton from "../components/FloatingButton";

class VideoDetailPage extends React.Component {

  constructor(props) {
    super(props);
    this.params = parse(this.props.location.search);
    this.pageData = pageFilter(this.props.artist, '../');
    this.state = {
      sharevideo: '',
      likevideo: '',
    }
    this.cookie = getArtistCookie(this.props.artist);
  }


  toggleshare = () => {
    if (this.state.sharevideo === '') {
      this.setState({ sharevideo: 'menu-active' });
    } else {
      this.setState({ sharevideo: '' });
    }
  }

  togglelike = () => {
    if (this.state.likevideo === '') {
      this.setState({ likevideo: 'liked' });
      axios.get('/w/api/' + this.pageData.artist.id + '/video/like/' + this.params.code + '?like=true',{headers:{
        PortalAuth: this.cookie
      }}).catch(error =>{

        document.location.href = "join";
      });;
    } else {
      this.setState({ likevideo: '' });
      axios.get('/w/api/' + this.pageData.artist.id + '/video/like/' + this.params.code + '?like=false',{headers:{
        PortalAuth: this.cookie
      }}).catch(error =>{
        document.location.href = "join";
      });
    }
  }
  onCopy = () => {
    this.setState({ copied: true, btn_copy: 'clicked-copy' });
  }
  componentDidMount() {
    var pass = this.params.bypass == 'cms';
    if(!pass && !this.cookie) {
        if (!hasAnoAccess(this.props.artist)) {
          document.location.href = "join";
          return;
        }
      }
    axios.get('/w/api/' + this.pageData.artist.id + '/video-detail?code=' + this.params.code,{headers:{
      PortalAuth: this.cookie
    }})
      .then(response => {
        var respData = response.data;
        this.setState(state => ({ data: respData, likevideo: respData.liked ? 'liked' : '' }));
      }).catch(error =>{
      document.location.href = "join";
      });
    ReactGA.pageview(window.location.pathname + window.location.search);
  }

  render() {
    const shareUrl = 'http://funseleb.com/w/' + this.pageData.artist.path + '/video-detail?code=' + this.params.code;
    const title = this.state.data ? this.state.data.title : '';
    return <>
      <CssLoader css={this.pageData.artist.css} />
      <Navbar back='../video' data={this.pageData} title="VIDEO" gohome={this.params.home} />
      {!this.state.data ? <Loading /> : (
        <>
          <div className="content video video-watch">
            <div>
              <video src={this.state.data.video_url}
                autoPlay poster={this.state.data.poster} controls></video>
            </div>
            <div className="container">
              {this.pageData.artist.floating_url && (
                  <FloatingButton url={this.pageData.artist.floating_url} />
              )}
              <div className="video-watch-detail">
                <div className="vwd-top">
                  <h4>{this.state.data.title}</h4>
                </div>
                <div className="vwd-bottom">
                  <Button color="none" className={['like-video', this.state.likevideo].join(' ')} onClick={this.togglelike}>
                    <span>
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 46 40">
                    <path className="a" transform="translate(11.5 9)" d="M23.252,2.2A6.791,6.791,0,0,0,18.2,0a6.354,6.354,0,0,0-3.968,1.37,8.119,8.119,0,0,0-1.6,1.675,8.114,8.114,0,0,0-1.6-1.675A6.353,6.353,0,0,0,7.055,0,6.792,6.792,0,0,0,2,2.2,7.894,7.894,0,0,0,0,7.59a9.4,9.4,0,0,0,2.5,6.153,53.412,53.412,0,0,0,6.27,5.885c.869.74,1.854,1.58,2.876,2.474a1.483,1.483,0,0,0,1.952,0c1.023-.894,2.008-1.734,2.877-2.475a53.387,53.387,0,0,0,6.27-5.885,9.4,9.4,0,0,0,2.5-6.153A7.894,7.894,0,0,0,23.252,2.2Zm0,0"/>
                  </svg>
                    </span><span>Like</span>
                  </Button>
                  <Button color="none" onClick={this.toggleshare}>
                    <span>
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 46 40">
                      <path className="a" transform="translate(525 -91)" d="M-492.652,97.374h0a2.048,2.048,0,0,0-1.769.24l-9.147,6.137-4.452,2.987h0l-6.755,4.533a2.418,2.418,0,0,0-1.06,2.212,2.417,2.417,0,0,0,1.216,1.9l4.183,1.852v-.023a1.188,1.188,0,0,0,1.027-.306l10.475-9.958a.278.278,0,0,1,.287-.057.284.284,0,0,1,.193.27.27.27,0,0,1-.076.188l-9.362,10.184a.6.6,0,0,0-.156.406v5.134a1.777,1.777,0,0,0,.892,1.574,1.731,1.731,0,0,0,1.317.153,1.731,1.731,0,0,0,1.039-.823l1.87-3.369,5.053,2.25a2.407,2.407,0,0,0,2.136-.089,2.407,2.407,0,0,0,1.222-1.754l3.239-21.39a1.931,1.931,0,0,0,.023-.308A2.039,2.039,0,0,0-492.652,97.374Zm-13.2,26.015a.535.535,0,0,1-.311.249.523.523,0,0,1-.42-.048.6.6,0,0,1-.268-.524v-4.21l2.819,1.256Zm13.384-23.958h0l-3.239,21.4a1.209,1.209,0,0,1-.62.885,1.192,1.192,0,0,1-1.062.043l-9.055-4.034,8.795-9.565a1.484,1.484,0,0,0-.049-2.062,1.484,1.484,0,0,0-2.062-.022l-10.474,9.96-3.692-1.648a1.219,1.219,0,0,1-.713-1.008,1.219,1.219,0,0,1,.533-1.113l20.354-13.656a.836.836,0,0,1,.859-.038.835.835,0,0,1,.438.74A.67.67,0,0,1-492.467,99.431Z"/>
                    </svg>
                    </span>
                    <span>Share</span>
                  </Button>
                </div>
              </div>
              <hr />
              <h4>Video Lain</h4>
              <ul className="video-list">
                {
                  utilLoopHelper(this.state.data.other.items, (item, index) => {
                    return <VideoList data={item} />
                  })
                }
              </ul>
            </div>
          </div>
          <div className={['share-video', this.state.sharevideo].join(' ')}>
            <div className="menu">
              <div className="menu-all">
                <div className="menu-top">
                  <ul>
                    <li><button className="btn btn-menu-close" onClick={this.toggleshare}><img src="http://resources.triyakom.com/mini_portal/close.svg" /></button></li>
                  </ul>
                </div>
                <div className="share-video-inner">
                  <div className="share-text">SHARE TO FRIEND</div>
                  <div className="menu-bottom">
                    <ul>
                      <li>
                        <FacebookShareButton url={shareUrl} quote={title}>
                          <Button color="none">
                            <span>
                              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40.018 40.018">
                                <path className="a" d="M35.015,0H5A5.007,5.007,0,0,0,0,5V35.015a5.007,5.007,0,0,0,5,5H35.015a5.007,5.007,0,0,0,5-5V5A5.007,5.007,0,0,0,35.015,0Z" />
                                <path className="b" d="M210.758,108.505h-6.253v-5c0-1.381,1.12-1.251,2.5-1.251h2.5V96h-5a7.5,7.5,0,0,0-7.5,7.5v5h-5v6.253h5v13.756h7.5V114.758h3.752Z" transform="translate(-176.993 -88.497)" />
                              </svg>
                            </span>
                            <span>FACEBOOK</span>
                          </Button>
                        </FacebookShareButton>
                      </li>
                      <li>
                        <TwitterShareButton url={shareUrl} quote={title}>
                          <Button color="none">
                            <span>
                              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40.018 40.018">
                                <g>
                                  <path className="a" d="M35.015,0H5A5.007,5.007,0,0,0,0,5V35.015a5.007,5.007,0,0,0,5,5H35.015a5.007,5.007,0,0,0,5-5V5A5.007,5.007,0,0,0,35.015,0Z" />
                                </g>
                                <path className="b" d="M24.73,50.379a10.57,10.57,0,0,1-2.921.8,5.041,5.041,0,0,0,2.23-2.8A10.132,10.132,0,0,1,20.825,49.6a5.07,5.07,0,0,0-8.77,3.467,5.22,5.22,0,0,0,.117,1.156,14.351,14.351,0,0,1-10.45-5.3A5.071,5.071,0,0,0,3.28,55.7a5.007,5.007,0,0,1-2.291-.624v.056a5.093,5.093,0,0,0,4.062,4.982,5.06,5.06,0,0,1-1.329.167,4.483,4.483,0,0,1-.96-.087A5.118,5.118,0,0,0,7.5,63.725a10.187,10.187,0,0,1-6.286,2.162A9.5,9.5,0,0,1,0,65.818a14.273,14.273,0,0,0,7.778,2.275,14.331,14.331,0,0,0,14.43-14.427c0-.224-.008-.441-.019-.655A10.114,10.114,0,0,0,24.73,50.379Z" transform="translate(9.195 -38.274)" />
                              </svg>
                            </span>
                            <span>TWITTER</span>
                          </Button>
                        </TwitterShareButton>
                      </li>
                      <li style={{ marginTop: "1.05em" }}>
                        <CopyToClipboard onCopy={this.onCopy} text={shareUrl}>
                          <Button color="none" className={this.state.btn_copy}>
                            <span>
                              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40.018 40.018">
                                <g transform="translate(0 0)">
                                  <path className="a" d="M35.015,0H5A5.007,5.007,0,0,0,0,5V35.015a5.007,5.007,0,0,0,5,5H35.015a5.007,5.007,0,0,0,5-5V5A5.007,5.007,0,0,0,35.015,0Z" transform="translate(0 0)" />
                                </g>
                                <g transform="translate(10.071 10.071)">
                                  <path className="b" d="M13.727,185.881a4.558,4.558,0,0,0-.014-.98,4.416,4.416,0,0,0-.293-1.128q-.027-.067-.057-.133a4.44,4.44,0,0,0-.918-1.331l-.017-.017a4.479,4.479,0,0,0-.845-.656l-1.395,1.38a.89.89,0,0,0-.249.452,2.093,2.093,0,0,1,.829.5l.008.008a2.094,2.094,0,0,1-.008,2.965l-4.757,4.707a2.191,2.191,0,0,1-3.034,0l-.008-.008a2.094,2.094,0,0,1,.008-2.965L5.7,185.984a5.616,5.616,0,0,1-.5-2.32q0-.268.025-.531L1.319,187a4.452,4.452,0,0,0-.017,6.309l.017.017a4.531,4.531,0,0,0,6.352,0l4.757-4.707a4.411,4.411,0,0,0,1.3-2.71Z" transform="translate(0 -174.495)" />
                                  <path className="b" d="M163.64,12.331a4.481,4.481,0,0,0,.845.656l1.395-1.38a.889.889,0,0,0,.249-.452,2.093,2.093,0,0,1-.829-.5l-.008-.008a2.094,2.094,0,0,1,.008-2.965l4.757-4.707a2.191,2.191,0,0,1,3.034,0l.006.006a2.094,2.094,0,0,1-.006,2.967L170.37,8.64a5.617,5.617,0,0,1,.5,2.32q0,.268-.025.531l3.908-3.866a4.452,4.452,0,0,0,.017-6.309l-.017-.017a4.531,4.531,0,0,0-6.352,0L163.64,6.006a4.452,4.452,0,0,0-.017,6.309l.017.017Z" transform="translate(-155.939 0.001)" />
                                </g>
                              </svg>
                            </span>
                            <span>COPY LINK</span>
                          </Button>
                        </CopyToClipboard>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )
      }
      <Footer />
    </>
  }
}

export default VideoDetailPage;